import React, { Component } from "react";
// react component for creating dynamic tables
import ReactTable from "react-table";
import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button,
} from "components";

//import Button from "components/CustomButton/CustomButton.jsx";

import moment from "moment";

import matchSorter from "match-sorter";


var firstCell = true;
//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = (key) => (array) =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

class MobileDetail extends Component {
  constructor(props) {
    super(props);
    moment.locale("es");

    let data = this.loadData();

    /* //console.log(props); */
    this.state = {
      data: data,
    };
    this.renderButton = this.renderButton.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  loadData(updateState) {
    let data = [];
    if (this.props.mainState.mobilesCDRLoaded) {
      let dataOrigin = this.props.mainState.mobilesCDR[
        this.props.match.params.mobileNumber
      ][0].cdr["Llamadas"];
      if (dataOrigin) {
        data = dataOrigin.map((prop, key) => {
          return {
            id: key,
            date: moment(prop.fecha, "D/MM/YYYY HH:mm:ss").format(
              "YYYY/MM/DD HH:mm:ss"
            ),
            destiny: prop.destino,
            description: this.cleanDescription(prop.descripción),
            duration: parseInt(parseFloat(prop.consumo)),
            cost: prop.importe, //,
            // actions: (
            //   // we've added some custom button actions
            //   <div className="actions-right">
            //     {/* use this button to add a like kind of action */}
            //     <Button
            //       onClick={() => {
            //         let obj = this.state.data.find(o => o.id === key);
            //         alert(
            //           "You've clicked LIKE button on \n{ \nName: " +
            //             obj.name +
            //             ", \nposition: " +
            //             obj.position +
            //             ", \noffice: " +
            //             obj.office +
            //             ", \nage: " +
            //             obj.age +
            //             "\n}."
            //         );
            //       }}
            //       color="info"
            //       size="sm"
            //       round
            //       icon
            //     >
            //       <i className="fa fa-heart" />
            //     </Button>{" "}
            //     {/* use this button to add a edit kind of action */}
            //     <Button
            //       onClick={() => {
            //         let obj = this.state.data.find(o => o.id === key);
            //         alert(
            //           "You've clicked EDIT button on \n{ \nName: " +
            //             obj.name +
            //             ", \nposition: " +
            //             obj.position +
            //             ", \noffice: " +
            //             obj.office +
            //             ", \nage: " +
            //             obj.age +
            //             "\n}."
            //         );
            //       }}
            //       color="warning"
            //       size="sm"
            //       round
            //       icon
            //     >
            //       <i className="fa fa-edit" />
            //     </Button>{" "}
            //     {/* use this button to remove the data row */}
            //     <Button
            //       onClick={() => {
            //         var data = this.state.data;
            //         data.find((o, i) => {
            //           if (o.id === key) {
            //             // here you should add some custom code so you can delete the data
            //             // from this component and from your server as well
            //             data.splice(i, 1);
            //             ////console.log(data);
            //             return true;
            //           }
            //           return false;
            //         });
            //         this.setState({ data: data });
            //       }}
            //       color="danger"
            //       size="sm"
            //       round
            //       icon
            //     >
            //       <i className="fa fa-times" />
            //     </Button>{" "}
            //   </div>
            // )
          };
        });
      }

      dataOrigin = this.props.mainState.mobilesCDR[
        this.props.match.params.mobileNumber
      ][0].cdr["SMS"];

      if (dataOrigin) {
        data = data.concat(
          this.props.mainState.mobilesCDR[
            this.props.match.params.mobileNumber
          ][0].cdr["SMS"].map((prop, key) => {
            return {
              id: key,
              date: moment(prop.fecha, "D/MM/YYYY HH:mm:ss").format(
                "YYYY/MM/DD HH:mm:ss"
              ),
              destiny: prop.destino,
              description: "(SMS) " + this.cleanDescription(prop.descripción),
              duration: parseInt(parseFloat(prop.consumo)),
              cost: prop.importe,
            };
          })
        );
      }
    }
    if (updateState) {
      this.setState({
        data: data,
      });
    } else {
      return data;
    }
  }

  componentDidMount() {
    this.props.getMobileCDRShort(this.props.match.params.mobileNumber);
  }

  componentWillUnmount() { }

  renderButton(content, type) {
    let button = null;
    let formattedContent = null;
    let spaceAfterIcon = "    ";
    let buttonIcon = null;

    switch (type) {
      case "cost":
        buttonIcon = <i className="now-ui-icons business_money-coins" />;
        content = String(content);
        if (!content.includes(".")) content = content + ".00";
        formattedContent =
          content
            .substring(
              0,
              content.indexOf(".") > 0
                ? content.indexOf(".") + 3
                : content.length
            )
            .replace(".", ",") + " €";
        button = (
          <Button
            color={parseFloat(content) > 0 ? "danger" : "primary"}
            size="sm"
          >
            {!this.props.mainState.smallDevice && buttonIcon}
            {spaceAfterIcon}
            {formattedContent}
          </Button>
        );
        break;
      case "duration":
        buttonIcon = <i className="now-ui-icons tech_watch-time" />;
        formattedContent = this.secondsToHms(content);
        button = (
          <Button color="default" size="sm">
            {!this.props.mainState.smallDevice && buttonIcon}
            {spaceAfterIcon}
            {formattedContent}
          </Button>
        );
        break;
      case "sms":
        buttonIcon = <i className="now-ui-icons ui-2_chat-round" />;
        formattedContent = content + " SMS";
        button = (
          <Button color="default" size="sm">
            {!this.props.mainState.smallDevice && buttonIcon}
            {spaceAfterIcon}
            {formattedContent}
          </Button>
        );
        break;
      case "date":
        buttonIcon = <i className="now-ui-icons ui-1_calendar-60" />;
        formattedContent = content;
        if (this.props.mainState.smallDevice) {
          formattedContent = (
            <div>
              {formattedContent.substring(0, formattedContent.indexOf(" ") + 1)}
              {<br />}
              {formattedContent.substring(formattedContent.indexOf(" ") + 1)}
            </div>
          );
        }
        button = (
          <Button color="info" size="sm">
            {!this.props.mainState.smallDevice && buttonIcon}
            {spaceAfterIcon}
            {formattedContent}
          </Button>
        );
        break;
      default:
        break;
    }

    return button;
  }
  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hora " : " horas ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minuto " : " minutos ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " segundo" : " segundos") : "";
    return hDisplay + mDisplay + sDisplay;
  }
  createDetailCards() {
    let mobileContent = null;
    if (this.props.mainState.mobilesCDRLoaded) {
      let CDR = this.props.mainState.mobilesCDR[
        this.props.match.params.mobileNumber
      ][0].cdr["Llamadas"];

      let CDRSMS = this.props.mainState.mobilesCDR[
        this.props.match.params.mobileNumber
      ][0].cdr["SMS"];

      let groupByDescription = groupBy("descripción");
      let CDRbyDescription = CDR ? groupByDescription(CDR) : null;
      let CDRSMSbyDescription = CDRSMS ? groupByDescription(CDRSMS) : null;
      ////console.log(
      //  "####################### CDR BY DESCRIPTION #######################"
      //);
      ////console.log(CDRbyDescription);

      if (CDR) {
        mobileContent = Object.keys(CDRbyDescription).map(
          (currentDescription, key) => {
            let totalUsage = 0;
            let totalCost = 0;
            let currentRegistries = CDRbyDescription[currentDescription];

            currentRegistries.map((currentRegistry, key2) => {
              totalUsage += parseInt(parseFloat(currentRegistry.consumo));
              totalCost += parseFloat(currentRegistry.importe);
            });
            totalUsage = this.renderButton(totalUsage, "duration");
            totalCost = this.renderButton(totalCost, "cost");
            return (
              <Col key={"LLAMADAS" + currentDescription} xs={12} md={4}>
                <Card className="card-stats card-raised">
                  <CardBody>
                    <Row>
                      <Col xs={12} md={12}>
                        <Statistics
                          iconState="primary"
                          icon="tech_mobile"
                          title={this.cleanDescription(currentDescription)}
                          subtitle={totalUsage + totalCost}
                          isSubtitleObject
                          isSubtitleObject2
                          subtitleObject={totalUsage}
                          subtitleObject2={totalCost}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            );
          }
        );
      }

      if (CDRSMS) {
        mobileContent = mobileContent.concat(
          Object.keys(CDRSMSbyDescription).map((currentDescription, key) => {
            let totalUsage = 0;
            let totalCost = 0;
            let currentRegistries = CDRSMSbyDescription[currentDescription];

            currentRegistries.map((currentRegistry, key) => {
              totalUsage += parseInt(parseFloat(currentRegistry.consumo));
              totalCost += parseFloat(currentRegistry.importe);
            });
            totalUsage = this.renderButton(totalUsage, "sms");
            totalCost = this.renderButton(totalCost, "cost");
            return (
              <Col key={"SMS" + currentDescription} xs={12} md={4}>
                <Card className="card-stats card-raised">
                  <CardBody>
                    <Row>
                      <Col xs={12} md={12}>
                        <Statistics
                          iconState="primary"
                          icon="tech_mobile"
                          title={this.cleanDescription(currentDescription)}
                          subtitle={totalUsage + totalCost}
                          isSubtitleObject
                          isSubtitleObject2
                          subtitleObject={totalUsage}
                          subtitleObject2={totalCost}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            );
          })
        );
      }
    } else {
      mobileContent = (
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Consumos"
                    subtitle="Cargando..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }

    return mobileContent;
  }
  cleanDescription(description) {
    description = description.replace("movil", "móvil");
    description = description.replace("españa", "España");
    description = description.replace("buzón", "Buzón");
    return description;
  }
  renderDestiny(number) {
    number = String(number);
    let destiny = null;
    if (number.startsWith("00")) {
      destiny = number.substring(0, 4) + " " + number.substring(4);
    } else if (number.length == 9) {
      destiny =
        number.substring(0, 3) +
        " " +
        number.substring(3, 6) +
        " " +
        number.substring(6);
    } else {
      destiny = number;
    }
    return destiny;
  }
  render() {
    if (this.props.mainState.mobilesCDRLoaded && !this.state.data)
      this.loadData(true);
    return (
      <div>
        <PanelHeader
          content={
            <div className="header text-center">
              <h2 className="title">
                {this.props.match.params.mobileNumber.substring(0, 3) +
                  " " +
                  this.props.match.params.mobileNumber.substring(3, 6) +
                  " " +
                  this.props.match.params.mobileNumber.substring(6, 9)}
              </h2>
              <p className="category">Lista de registros del móvil</p>
            </div>
          }
        />
        <div className="content">
          <Row>{this.createDetailCards()}</Row>
          {this.props.mainState.mobilesCDRLoaded && this.state.data && (
            <Row>
              <Col xs={12} md={12}>
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Registro de llamadas</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <ReactTable
                      data={this.state.data}
                      filterable
                      columns={[
                        {
                          Header: "Fecha",
                          headerClassName: "text-center",
                          className: "text-center",
                          accessor: "date",
                          id: "date",
                          minWidth: 100,
                          filterable: false,
                          Cell: (row) => (
                            <div>
                              {/*prop.importe.substring(0, prop.importe.length - 2) + " €"*/}
                              {this.renderButton(row.value, "date")}
                            </div>
                          ),
                        },
                        {
                          Header: "Destino",
                          headerClassName: "text-center",
                          className: "text-center",
                          accessor: "destiny",
                          sortMethod: (a, b) => {
                            return parseInt(a) > parseInt(b) ? 1 : -1;
                          },
                          Cell: (row) => (
                            <div>
                              {this.renderDestiny(row.value)}
                              {/*prop.importe.substring(0, prop.importe.length - 2) + " €"*/}
                              {/* this.renderButton(row.value, "duration") */}
                            </div>
                          ),
                        },
                        {
                          Header: "Descripción",
                          headerClassName: "text-center",
                          className: "text-center",
                          accessor: "description",
                          show: !this.props.mainState.smallDevice,
                        },
                        {
                          Header: "Duración",
                          headerClassName: "text-center",
                          className: "text-center",
                          accessor: "duration",
                          Cell: ({ row, original }) => {
                            if (firstCell) {
                              firstCell = false;
                            }
                            return (
                              <div>
                                {/*prop.importe.substring(0, prop.importe.length - 2) + " €"*/}
                                {this.renderButton(
                                  row.duration,
                                  row.description.includes("SMS")
                                    ? "sms"
                                    : "duration"
                                )}
                              </div>
                            );
                          },
                          show: !this.props.mainState.smallDevice,
                        },
                        {
                          Header: "Coste",
                          headerClassName: "text-center",
                          className: "text-center",
                          accessor: "cost",
                          sortMethod: (a, b) => {
                            return parseFloat(a) > parseFloat(b) ? 1 : -1;
                          },
                          Cell: (row) => (
                            <div>
                              {/*prop.importe.substring(0, prop.importe.length - 2) + " €"*/}
                              {this.renderButton(row.value, "cost")}
                            </div>
                          ),
                        } /* ,
                      {
                        Header: "Actions",
                        accessor: "actions",
                        sortable: false,
                        filterable: false
                      } */,
                      ]}
                      defaultSorting={[
                        {
                          id: "date",
                          desc: true,
                        },
                      ]}
                      defaultPageSize={20}
                      defaultFilterMethod={(filter, row) =>
                        String(row[filter.id])
                          .toLowerCase()
                          .includes(filter.value.toLowerCase())
                      }
                      showPaginationTop
                      showPaginationBottom={false}
                      className="-striped -highlight"
                      previousText="Anterior"
                      nextText="Siguiente"
                      loadingText="Cargando..."
                      noDataText="No hay registros"
                      pageText="Página"
                      ofText="de"
                      rowsText="filas"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </div>
    );
  }
}

export default MobileDetail;



// WEBPACK FOOTER //
// ./src/views/Mobiles/MobileDetail.jsx